/* eslint-disable react/prop-types */
import SendIcon from "@mui/icons-material/Send";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { useSnackbar } from "notistack";
import { useState } from "react";
import * as yup from "yup";
import { sendEmailToolTest } from "apis/controllers/emailTool";
import { CssTextField } from "qubCommon/Inputs/CssTextField";
import { getResponseMessage, isSuccessResponse } from "../mailToolUtils";

const emailSchema = yup
  .string()
  .trim()
  .required("Το email είναι υποχρεωτικό")
  .email("Συμπληρώστε μια έγκυρη διεύθυνση email")
  .max(320, "Το email δεν μπορεί να ξεπερνά τους 320 χαρακτήρες");

const TestEmailDialog = ({ open, message, onClose }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const closeDialog = () => {
    setEmail("");
    setError("");
    onClose();
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    let recipientEmail;
    try {
      recipientEmail = emailSchema.validateSync(email);
    } catch (validationError) {
      setError(validationError.message);
      return;
    }

    setLoading(true);
    try {
      const response = await sendEmailToolTest({
        email: recipientEmail,
        subject: message?.subject || "",
        body: message?.body || "",
      });

      if (!isSuccessResponse(response)) {
        enqueueSnackbar(
          getResponseMessage(
            response,
            "Το backend δεν επιβεβαίωσε την αποστολή του δοκιμαστικού email"
          ),
          { variant: "error" }
        );
        return;
      }

      enqueueSnackbar(
        getResponseMessage(response, "Το δοκιμαστικό email μπήκε σε σειρά αποστολής."),
        { variant: "success" }
      );
      closeDialog();
    } catch (requestError) {
      enqueueSnackbar(
        getResponseMessage(
          requestError,
          "Δεν ήταν δυνατή η αποστολή του δοκιμαστικού email"
        ),
        { variant: "error" }
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : closeDialog}
      aria-describedby="test-email-dialog-description"
      maxWidth="xs"
      fullWidth
      PaperProps={{ component: "form", noValidate: true, onSubmit: handleSubmit }}
    >
      <DialogTitle>Αποστολή Δοκιμαστικού Email</DialogTitle>
      <DialogContent>
        <DialogContentText id="test-email-dialog-description" sx={{ mb: 2 }}>
          Συμπληρώστε το email στο οποίο θα σταλεί η προεπισκόπηση.
        </DialogContentText>
        <CssTextField
          autoFocus
          fullWidth
          type="email"
          label="Email παραλήπτη"
          value={email}
          onChange={(event) => {
            setEmail(event.target.value);
            setError("");
          }}
          error={Boolean(error)}
          helperText={error}
          disabled={loading}
          inputProps={{ maxLength: 320 }}
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={closeDialog} disabled={loading}>
          Ακύρωση
        </Button>
        <Button
          type="submit"
          variant="contained"
          disabled={loading}
          startIcon={
            loading ? (
              <CircularProgress color="inherit" size={16} />
            ) : (
              <SendIcon />
            )
          }
        >
          Αποστολή
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TestEmailDialog;
